// Absolute URLs (canonical, og:*, JSON-LD) must never be derived from
// `window.location.origin`. The build-time prerender step
// (scripts/prerender.mjs) navigates a real headless browser to a local
// static server on an ephemeral loopback port to snapshot each route, so
// `window.location.origin` resolves to that throwaway address -- not the
// real domain -- and gets baked verbatim into the shipped HTML. This is a
// fixed, build-time constant instead, set the same way as the other
// VITE_* config in src/conf/index.js.
export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://www.secureonelabs.com';
